import Base from './base'

export default class MarketIntelligence extends Base {
  list(data: object = {}) {
    return this.apiClient.get('market-intelligence', data)
  }

  show(id: string) {
    return this.apiClient.get(`market-intelligence/${id}`, {})
  }

  create(data: object) {
    return this.apiClient.post('market-intelligence', data)
  }

  update(id: string, data: object) {
    return this.apiClient.put(`market-intelligence/${id}`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`market-intelligence/${id}`)
  }

  addTags(id: string, tags: object[]) {
    return this.apiClient.post(`market-intelligence/${id}/tags`, { tags })
  }

  resolveTag(id: string, data: object) {
    return this.apiClient.put(`market-intelligence/tags/${id}`, data)
  }

  deleteTag(id: string) {
    return this.apiClient.delete(`market-intelligence/tags/${id}`)
  }

  createTagTarget(data: { kind: string; name: string }) {
    return this.apiClient.post('market-intelligence/tag-targets', data)
  }
}
